/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_HeadingInputs */

const tr_iade_iptal_s2_heading = /** @type {(inputs: Iade_Iptal_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Tanımlar`)
};

const en_iade_iptal_s2_heading = /** @type {(inputs: Iade_Iptal_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Definitions`)
};

const de_iade_iptal_s2_heading = /** @type {(inputs: Iade_Iptal_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Begriffsbestimmungen`)
};

const ru_iade_iptal_s2_heading = /** @type {(inputs: Iade_Iptal_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Определения`)
};

/**
* | output |
* | --- |
* | "2. Definitions" |
*
* @param {Iade_Iptal_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_heading = /** @type {((inputs?: Iade_Iptal_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_heading(inputs)
	if (locale === "de") return de_iade_iptal_s2_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_heading(inputs)
	return tr_iade_iptal_s2_heading(inputs)
});